export function initHotelSingleSlider() {
    if (typeof window === "undefined" || !window.Swiper) {
        return;
    }

    // ── Main gallery with manual thumb sync (no Swiper Thumbs module) ──────
    const mains = document.querySelectorAll("[data-dopline-hotel-slider-main]");
    mains.forEach((mainNode) => {
        if (mainNode.dataset.sliderReady === "1") return;

        const slidesCount = mainNode.querySelectorAll(
            ".swiper-slide:not(.swiper-slide-duplicate)"
        ).length;
        if (slidesCount < 1) return;

        const inner = mainNode.closest(".dopline-hotel-single__gallery-inner");
        const thumbsNode = inner
            ? inner.querySelector("[data-dopline-hotel-slider-thumbs]")
            : null;

        const pagination = mainNode.querySelector(".swiper-pagination");
        const nextEl = mainNode.querySelector(".dopline-hotel-single__nav--next");
        const prevEl = mainNode.querySelector(".dopline-hotel-single__nav--prev");

        // Main slider — no thumbs option to avoid height-collapse bug
        const mainSwiper = new window.Swiper(mainNode, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 520,
            loop: slidesCount > 1,
            grabCursor: true,
            keyboard: { enabled: true },
            pagination: { el: pagination, clickable: true },
            navigation: { nextEl, prevEl },
        });

        if (slidesCount < 2) {
            if (pagination) pagination.style.display = "none";
            if (nextEl) nextEl.style.display = "none";
            if (prevEl) prevEl.style.display = "none";
            mainSwiper.disable();
        }

        // Thumb strip — separate Swiper for free-scroll; sync manually
        if (thumbsNode && slidesCount > 1) {
            const thumbsSwiper = new window.Swiper(thumbsNode, {
                slidesPerView: "auto",
                spaceBetween: 8,
                freeMode: true,
                watchSlidesProgress: false,
            });

            const thumbSlides = Array.from(
                thumbsNode.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)")
            );

            function setActiveThumb(realIndex) {
                thumbSlides.forEach((t, i) => {
                    t.classList.toggle("swiper-slide-thumb-active", i === realIndex);
                });
                // Scroll thumb strip so active thumb is visible
                if (realIndex < thumbsSwiper.slides.length) {
                    thumbsSwiper.slideTo(realIndex, 300);
                }
            }

            // Init first active thumb
            setActiveThumb(0);

            // Main changes → update thumbs
            mainSwiper.on("slideChange", () => {
                setActiveThumb(mainSwiper.realIndex);
            });

            // Click on thumb → go to that slide
            thumbSlides.forEach((thumb, idx) => {
                thumb.addEventListener("click", () => {
                    if (mainSwiper.params.loop) {
                        mainSwiper.slideToLoop(idx);
                    } else {
                        mainSwiper.slideTo(idx);
                    }
                });
            });
        }

        mainNode.dataset.sliderReady = "1";
    });

    // ── Room mini-sliders with thumbnail sync ──────────────────────────────
    const roomSliders = document.querySelectorAll("[data-dopline-room-slider]");
    roomSliders.forEach((node) => {
        if (node.dataset.sliderReady === "1") return;

        const slidesCount = node.querySelectorAll(
            ".swiper-slide:not(.swiper-slide-duplicate)"
        ).length;
        if (slidesCount < 1) return;

        node.dataset.sliderReady = "1";

        const nextEl = node.querySelector(".dopline-room-card__nav--next");
        const prevEl = node.querySelector(".dopline-room-card__nav--prev");

        // Defer init by one RAF so the grid/flex layout has painted and Swiper
        // can read the real container width (avoids the "width: 17895700px" bug).
        requestAnimationFrame(() => {
            const slider = new window.Swiper(node, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 380,
                loop: slidesCount > 1,
                grabCursor: true,
                navigation: { nextEl, prevEl },
                observer: true,
                observeParents: true,
            });

            // Sync thumbnail strip
            const groupId = node.id;
            if (groupId) {
                const thumbs = document.querySelectorAll(
                    `[data-dopline-room-thumb="${groupId}"]`
                );

                slider.on("slideChange", () => {
                    const idx = slider.realIndex;
                    thumbs.forEach((t, i) => t.classList.toggle("is-active", i === idx));
                });

                thumbs.forEach((thumb) => {
                    thumb.addEventListener("click", () => {
                        slider.slideTo(parseInt(thumb.dataset.idx, 10));
                    });
                });
            }

            if (slidesCount < 2) {
                if (nextEl) nextEl.style.display = "none";
                if (prevEl) prevEl.style.display = "none";
                slider.disable();
            }
        });
    });
}
